import React from 'react';
import LegalPage from '../components/LegalPage';

const Disclaimers: React.FC = () => {
  const disclaimersContent = (
    <>
      <p className="disclaimer-highlight">
        DISCLAIMER: TranslateStocks.com is not a registered investment advisor or broker/dealer. All information provided on the TranslateStocks.com websites is provided as-is and does not represent personalized investment advice. These sites do not constitute a representation by the publisher or a solicitation for the purchase or sale of securities. All opinions provided are based on sources believed to be reliable and are written in good faith, but no warranty or representation, expressed or implied, is made as to their accuracy. There are risks associated with any investment and we strongly encourage readers to supplement the information in these articles, special reports, and newsletters with independent research and other professional advice before investing in any security.
      </p>
      
      <p>
        Investing is inherently risky. While a potential for rewards exists, by investing, you are putting yourself at risk. You must be aware of the risks and be willing to accept them in order to invest in any type of security.
      </p>
      
      <p>
        Don't trade with money you can't afford to lose. This is neither a solicitation nor an offer to Buy/Sell securities. No representation is being made that any account will or is likely to achieve profits or losses similar to those discussed on this web site. The past performance of any trading system or methodology is not necessarily indicative of future results.
      </p>
      
      <div className="disclaimer-special">
        <p>
          CFTC RULE 4.41 - HYPOTHETICAL OR SIMULATED PERFORMANCE RESULTS HAVE CERTAIN LIMITATIONS. UNLIKE AN ACTUAL PERFORMANCE RECORD, SIMULATED RESULTS DO NOT REPRESENT ACTUAL TRADING. ALSO, SINCE THE TRADES HAVE NOT BEEN EXECUTED, THE RESULTS MAY HAVE UNDER-OR-OVER COMPENSATED FOR THE IMPACT, IF ANY, OF CERTAIN MARKET FACTORS, SUCH AS LACK OF LIQUIDITY. SIMULATED TRADING PROGRAMS IN GENERAL ARE ALSO SUBJECT TO THE FACT THAT THEY ARE DESIGNED WITH THE BENEFIT OF HINDSIGHT. NO REPRESENTATION IS BEING MADE THAT ANY ACCOUNT WILL OR IS LIKELY TO ACHIEVE PROFIT OR LOSSES SIMILAR TO THOSE SHOWN.
        </p>
      </div>

      
    <div className="disclaimer-page">      
      <title>Price on Rails Trading Bot Legal Disclaimer | Translate Stocks</title>
      <meta name="description" content="Important legal disclaimer for the Price on Rails Bot trading feature. Understand how our AI trading assistant works and the responsibilities of users." />
      
      <div className="page-header">
        <div className="container">
          <h1>Price on Rails Bot Legal Disclaimer</h1>
          <p>Important information about using our automated trading features</p>
        </div>
      </div>

      <div className="disclaimer-content">
        <div className="container">
          <div className="disclaimer-card">
            <div className="disclaimer-intro">
              <p>
                <strong>Before using our Price on Rails Bot feature, please review this important information carefully.</strong> The information below clarifies how the bot operates and outlines the responsibilities of users.
              </p>
            </div>

            <div className="disclaimer-section">
              <h2>How the Price on Rails Bot Operates</h2>
              
              <p>The Price on Rails Bot (PR Bot) trading feature operates <strong>locally</strong> on your screen, which means:</p>
              
              <ul>
                <li>It makes decisions based <strong>exclusively</strong> on what you see in your real-time charts</li>
                <li>It does not receive external trading signals or remote feeds outside your local environment</li>
              </ul>
            </div>

            <div className="disclaimer-section">
              <h2>Performance Considerations</h2>
              
              <p>Several factors can affect how the bot operates and may lead to different outcomes:</p>
              
              <div className="disclaimer-grid">
                <div className="disclaimer-item">
                  <h3>Chart Lag or Data Gaps</h3>
                  <p>If your charts experience lag, the bot might miss key data points and fail to execute trades at intended times.</p>
                </div>
                
                <div className="disclaimer-item">
                  <h3>System Resources</h3>
                  <p>Heavy CPU or memory usage can delay data processing and affect the bot's ability to recognize entry/exit points in real time.</p>
                </div>
                
                <div className="disclaimer-item">
                  <h3>System Variations</h3>
                  <p>Different computers may produce different trading actions due to variations in local processing times and user interactions.</p>
                </div>
                
                <div className="disclaimer-item">
                  <h3>Remote Desktop Use</h3>
                  <p>Remote sessions can slow data processing. For best results, ensure a stable connection or consider our web-based version.</p>
                </div>
              </div>
            </div>

            <div className="disclaimer-section">
              <h2>Important Usage Guidelines</h2>
              
              <div className="disclaimer-grid">
                <div className="disclaimer-item">
                  <h3>Collaborative Trading</h3>
                  <p>The PR Bot is designed to trade <strong>alongside</strong> you using "Buy View" or "Sell View" features. Manual trades are not recognized by the bot.</p>
                </div>
                
                <div className="disclaimer-item">
                  <h3>Not an HFT Solution</h3>
                  <p>The bot mimics an experienced human trader but is not designed for high-frequency trading. It cannot handle complex scenarios like broker overrides.</p>
                </div>
                
                <div className="disclaimer-item">
                  <h3>Software Dependencies</h3>
                  <p>The bot depends on several core processes. Closing any of these will cause the bot to stop functioning.</p>
                </div>
                
                <div className="disclaimer-item">
                  <h3>Margin Considerations</h3>
                  <p>The bot is designed for initial margins. Using day-trade margins significantly increases risk and should be approached with caution.</p>
                </div>
              </div>
            </div>

            <div className="disclaimer-section">
              <h2>User Responsibility Statement</h2>
              <div className="responsibility-box">
                <p>By using the Price on Rails Bot feature, you acknowledge that:</p>
                <ul>
                  <li>You bear <strong>full responsibility</strong> for all trading results</li>
                  <li>You are responsible for ensuring compliance with broker rules</li>
                  <li>TranslateStocks is <strong>not</strong> a registered investment adviser</li>
                  <li>This feature does <strong>not</strong> provide professional trading advice</li>
                  <li>All trading carries risk</li>
                  <li>TranslateStocks and its affiliates accept <strong>no liability</strong> for penalties, losses, or missed profits</li>
                </ul>
                <p className="final-statement">If you're uncomfortable with any of these points, <strong>do not proceed</strong> with using the bot.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
      
      <p>
        All trades, patterns, charts, systems, etc., discussed in this website and the product materials are for illustrative purposes only and not to be construed as specific advisory recommendations.
      </p>
    </>
  );

  return (
    <LegalPage 
      title="Disclaimers"
      content={disclaimersContent}
    />
  );
};

export default Disclaimers;